import React, { useCallback, useState } from 'react';
import { CenteredModal } from '@app/core';
import { VerifyPhoneViaCodeContent } from './VerifyPhoneViaCodeContent';
import { useTranslation } from 'react-i18next';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  modal: {
    overflow: 'visible',
  },
}));

interface Props {
  isOpen: boolean;
  onRequestClose: () => any;
  phone?: string;
  text?: React.ReactNode | string;
  participantId?: string;
  onSuccess?: () => void;
}

export const VerifyPhoneViaCodeModal = ({
  phone,
  text,
  isOpen,
  onRequestClose,
  participantId,
  onSuccess,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation('common');
  const [title, setTitle] = useState(
    t('login.phoneVerificationValidationCode.title'),
  );

  const updateTitle = useCallback((newTitle: string) => setTitle(newTitle), []);

  return (
    <CenteredModal
      title={title}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={classes.modal}
    >
      <VerifyPhoneViaCodeContent
        phone={phone}
        text={text}
        participantId={participantId}
        onTitleChange={updateTitle}
        onSuccess={onSuccess}
      />
    </CenteredModal>
  );
};
